import styled from "styled-components";

export const Container = styled.div`
  width: 50%;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  color: #f2f2f2;
  margin: auto;

  svg {
    color: #bdbdbd;
    margin-bottom: 32px;
  }

  h2 {
    font-weight: normal;
  }

  div {
    color: #bdbdbd;
    font-size: 14px;
    margin-bottom: 32px;
    width: 340px;
  }
`;
